module.exports = "/assets/cola-page/hero@2x.png?w/7iTi2";